import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const LeftArrowIcon = ({ size }: IconSvgProps) => {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} role="presentation">
            <path fill="#fff" fillOpacity=".01" d="M0 0h24v24H0z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.207 5.793a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.793 3.793a1 1 0 11-1.415 1.414l-5.499-5.5A.997.997 0 015 12.028v-.057a.996.996 0 01.293-.678l5.499-5.5a1 1 0 011.415 0z"
                fill="currentColor"
            />
        </svg>
    );
};
